module.exports = __webpack_public_path__ + "img/order-on.a5a4d85e.svg";